import React from 'react';
import classNames from 'classnames';
import * as styles from './wrapper.module.sass'
import { WrapperProps } from './props.types';
import { Card } from '../../templates/Card';
import { Section } from '../../enums/container';

export const Wrapper = (props: WrapperProps) => {
  const {
    children,
    className,
    vertical = false,
    section,
    cardClassName,
    color,
    background_color = '',
  } = props;


  return (
    <div
      className={classNames(
        className,
        styles.wrapper,
        styles[background_color],
        { [styles.wrapper_vertical]: vertical }
      )}
    >
      <Card section={section} className={cardClassName} color={color} children={children} heading_left={props.heading_left}/>
    </div>
  );
};
